// SERVICES-001 Courses (owner, 2026-10-24; D-054): the shop's Courses page (how-to videos in an
// embedded player) and the owner console's Courses section. Our own wording.
export const coursesStrings = {
  title: "Learn Adyvance",
  lead: "Short videos from the Adyvance team on running your store. Watch them right here.",
  videos: "{count} videos",
  videosOne: "1 video",
  watched: "{done} of {total} watched",
  all: "All",
  other: "More videos",
  search: "Search videos",
  noMatch: "No video matches your search.",
  watchedBadge: "Watched",
  play: "Play",
  continue: "Continue",
  start: "Start here",
  upNext: "Up next",
  prev: "Previous",
  next: "Next",
  close: "Close",
  markWatched: "Mark as watched",
  markUnwatched: "Mark as not watched",
  openYoutube: "Open on YouTube",
  empty: {
    title: "Videos are on the way",
    body: "The Adyvance team is recording how-to videos. They'll show here as soon as they're published.",
  },
  console: {
    title: "Courses",
    lead: "How-to videos for shop owners. Paste a YouTube link: shops watch it on their Courses page without leaving Adyvance.",
    add: "Add video",
    link: "YouTube link",
    linkPh: "youtube.com/watch?v=… or youtu.be/…",
    titleLabel: "Title",
    titleHint: "Left empty, the YouTube title is used.",
    description: "Description (optional)",
    section: "Section",
    noSection: "No section",
    publish: "Show to shops",
    added: "Video added",
    saved: "Saved",
    removed: "Video removed",
    remove: "Remove",
    removeConfirm: "Remove this video from Courses? It stays on YouTube.",
    edit: "Edit",
    hidden: "Hidden",
    shown: "Shown",
    up: "Move up",
    down: "Move down",
    sections: "Sections",
    sectionsLead: "Group videos, in the order shops see them.",
    addSection: "Add",
    sectionTitle: "Section name",
    saveSections: "Save",
    sectionsSaved: "Sections saved",
    empty: "No videos yet. Add the first one above.",
    count: "{count} videos",
    countOne: "1 video",
    save: "Save",
    cancel: "Cancel",
  },
} as const;
